module.exports = "https://la-static.vkplay.ru/promo/3/img/popup-prize.7429c116.png";